import { render, staticRenderFns } from "./CurrentZipsTotals.vue?vue&type=template&id=45946269&scoped=true&"
import script from "./CurrentZipsTotals.vue?vue&type=script&lang=js&"
export * from "./CurrentZipsTotals.vue?vue&type=script&lang=js&"
import style0 from "./CurrentZipsTotals.vue?vue&type=style&index=0&id=45946269&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45946269",
  null
  
)

export default component.exports